import React from "react";
import { SEO } from "@/components/common/SEO";
import { Breadcrumbs } from "@/components/common/Breadcrumbs";
import { SectionHeading } from "@/components/common/SectionHeading";
import { CollectionCard } from "@/components/product/CollectionCard";
import { Reveal } from "@/components/common/Reveal";
import { useCollections } from "@/hooks/useCatalog";

export default function CollectionsIndexPage() {
  const { data } = useCollections();
  const collections = data?.collections || [];

  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8 lg:py-14">
      <SEO title="Collections" description="Explore all ÉLORA jewellery collections — necklaces, earrings, rings, bracelets, bangles and bridal sets." />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Collections" }]} />
      <div className="mt-8">
        <SectionHeading eyebrow="Explore" title="Our Collections" subtitle="Six signature edits, each crafted with intention and an eye for timeless beauty." />
      </div>
      <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {collections.map((c, i) => (
          <Reveal key={c.handle} delay={(i % 3) * 0.08}>
            <CollectionCard collection={c} />
          </Reveal>
        ))}
      </div>
    </div>
  );
}
